import { AxiosError } from "axios";
import { useMemo } from "react";
import useSWR from "swr";

import { userEndpoints } from "@api/Endpoints";
import { OrganizationUser } from "@organization/models/OrganizationUser";

import { fetcher } from "@utils/swrUtils";

export function useGetUserOfCurrentOrganization(userId: string | null) {
  let url: null | string = null;

  if (userId) {
    url = userEndpoints.getUserByCurrentOrganization(userId);
  }

  const { data, error, isLoading } = useSWR<OrganizationUser, AxiosError>(
    url,
    fetcher
  );

  // 200 - GET /api/organizations/current/users/{GUID} - user exist
  // 500 - GET /api/organizations/current/users/{GUID} - user does not exists (in fact CP BFF has 404 under the hood towards)

  return useMemo(() => ({ data, isLoading, error }), [data, isLoading, error]);
}
